import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-229734e9")

_pushScopeId("data-v-229734e9")
const _hoisted_1 = { id: "imageEditor" }
const _hoisted_2 = { class: "label heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Dimensions", -1)
const _hoisted_5 = { class: "settings-row" }
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "W", -1)
const _hoisted_10 = { class: "settings-row" }
const _hoisted_11 = { class: "input-box" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
const _hoisted_13 = { class: "input-box" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "H", -1)
const _hoisted_15 = { class: "settings-row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Keep ratio", -1)
const _hoisted_17 = { class: "settings-row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Dithering", -1)
const _hoisted_19 = { class: "intensity-value" }
const _hoisted_20 = { class: "settings-row" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Preview loading component", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.gifMode ? "GIF" : "Image") + " ", 1 /* TEXT */),
      _createVNode("input", {
        type: "text",
        class: "imageNameInput",
        onInput: _cache[1] || (_cache[1] = val => _ctx.component.setImageUrl(val.target.value)),
        value: _ctx.component.imageUrl
      }, null, 40, ["value"])
    ]),
    _hoisted_3,
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[2] || (_cache[2] = $event => (_ctx.inputTransformer($event, _ctx.component.x))),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.component.x = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.x,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_7
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[4] || (_cache[4] = $event => (_ctx.inputTransformer($event, _ctx.component.width))),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.component.width = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.width,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_9
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[6] || (_cache[6] = $event => (_ctx.inputTransformer($event, _ctx.component.y))),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.component.y = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.y,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_12
      ]),
      _createVNode("div", _hoisted_13, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[8] || (_cache[8] = $event => (_ctx.inputTransformer($event, _ctx.component.height))),
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.component.height = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.height,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_14
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _hoisted_16,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.component.keepImageRatio = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.component.keepImageRatio]
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _hoisted_18,
      _withDirectives(_createVNode("input", {
        class: "intensity-range",
        type: "range",
        min: "0",
        max: "100",
        step: "1",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.component.ditheringIntensity = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.component.ditheringIntensity,
          void 0,
          { number: true }
        ]
      ]),
      _createVNode("span", _hoisted_19, _toDisplayString(_ctx.component.ditheringIntensity) + "%", 1)
    ]),
    _createVNode("div", _hoisted_20, [
      _hoisted_21,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.component.drawLoading = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.component.drawLoading]
      ])
    ])
  ]))
})